import React, { PureComponent } from "react";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { Button, ButtonGroup, Dropdown } from "aible";

import { isEnabled } from "utils/featureFlags";

import Select from "react-select";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { LineInput } from "components/Inputs/LineInput";
import CapSlider from "components/Project/CapSlider";
import RadarChart from "components/Project/RadarChart";
import CompareWaterfall from "components/Waterfall/CompareWaterfall";

import { FRONTIER_SLIDERS_VIEW } from "containers/FrontierSliders/FrontierSliders";

import styles from "./style.module.css";

export default class CompareScenario extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { isCompareScenarioHistory: false, compareElement: "Profit" };
  }

  render() {
    const {
      project,
      optimized,
      optimizer,
      onClose,
      modelGroups,
      compareScenarioIndex,
      viewingScenarioIndex,
      updateCompareScenarioIndex,
      viewScenario,
      compareScenario,
      selectedScenario,
      sliderView,
      updateSliderView
    } = this.props;
    const { isCompareScenarioHistory } = this.state;

    let compareElement = this.state.compareElement;

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    if (isContinuous && (compareElement === "Profit" || compareElement === "Revenue" || compareElement === "Cost")) {
      compareElement === "Error Cost";
    }

    const assumptionCharts =
      project && project.settings && project.settings.scenarios && project.settings.scenarios[viewingScenarioIndex]
        ? Object.keys(project.settings.scenarios[viewingScenarioIndex])
            .filter((k) => optimizer.drilldownValue === "Overall" || optimizer.drilldownValue === k)
            .filter((k) => k !== "Overall")
            .filter(
              (k) => Object.keys(project.settings.scenarios[viewingScenarioIndex][k].setup.data.customValues).length > 0
            )
        : [];

    const viewingScenario =
      project &&
      project.settings &&
      project.settings.originalScenarios &&
      project.settings.originalScenarios[viewingScenarioIndex];

    const hoverScenario =
      project &&
      project.settings &&
      project.settings.originalScenarios &&
      project.settings.originalScenarios[compareScenarioIndex];

    const profitDelta =
      project &&
      project.settings &&
      project.settings.scenarioStats &&
      project.settings.scenarioStats[viewingScenarioIndex] &&
      project.settings.scenarioStats[compareScenarioIndex]
        ? (
            ((project.settings.scenarioStats[viewingScenarioIndex][compareElement.toLowerCase()] -
              project.settings.scenarioStats[compareScenarioIndex][compareElement.toLowerCase()]) /
              project.settings.scenarioStats[compareScenarioIndex][compareElement.toLowerCase()]) *
            100
          ).toFixed(2)
        : undefined;

    return (
      <div className={styles.compareHolder}>
        <div className={styles.compare}>
          <div className={styles.compareBody}>
            <div className={styles.otherHeader} style={{ justifyContent: "flex-start" }}>
              {viewingScenario && hoverScenario && viewingScenarioIndex !== compareScenarioIndex
                ? "Comparing " +
                  viewingScenario.name +
                  " to " +
                  hoverScenario.name +
                  ": " +
                  viewingScenario.name +
                  " has " +
                  Math.abs(profitDelta).toFixed(2) +
                  "%" +
                  (profitDelta > 0 ? " higher " : " lower ") +
                  compareElement
                : viewingScenario
                  ? "Comparing " + viewingScenario.name
                  : "Scenario Comparison"}
            </div>
            <Button onClick={() => onClose()} className={styles.closeCompare}>
              {"Close Comparison"}
            </Button>
            <div className={styles.cHeader}>
              <div className={styles.cFlex}>
                <div className={styles.cLarge + " " + styles.cFirst}>
                  {"Key Differences"}
                  <div className={styles.scenSelect}>
                    <Select
                      options={
                        isContinuous
                          ? [
                              {
                                label: "Overestimate Impact",
                                value: "Overestimate Impact"
                              },
                              {
                                label: "Underestimate Impact",
                                value: "Underestimate Impact"
                              },
                              { label: "Error Cost", value: "Error Cost" }
                            ]
                          : [
                              { label: "Profit", value: "Profit" },
                              { label: "Revenue", value: "Revenue" },
                              { label: "Cost", value: "Cost" }
                            ]
                      }
                      value={[{ label: compareElement, value: compareElement }]}
                      onChange={(val) => this.setState({ compareElement: val.value })}
                      menuPlacement={"bottom"}
                    />
                  </div>
                </div>
                <div className={styles.cSmall} style={{ minWidth: "16vw", width: "16vw" }}>
                  {"Assumptions"}
                </div>
                <div className={styles.cSmall} style={{ minWidth: "17vw", width: "17vw" }}>
                  {"Assumption Impacts"}
                </div>
                <div className={styles.cSmall}>{"Transactions"}</div>
                <div className={styles.cSmall}>{"Top Prediction Drivers"}</div>
              </div>
            </div>
            <div className={styles.cBody}>
              <div className={styles.cFlex}>
                <div className={styles.cLargeFix}>
                  {project &&
                  project.settings &&
                  project.settings.scenarioStats &&
                  project.settings.scenarioStats[viewingScenarioIndex] &&
                  project.settings.scenarioStats[compareScenarioIndex] &&
                  project.settings.scenarios.length > Math.max(viewingScenarioIndex, compareScenarioIndex) - 1 ? (
                    <div className={styles.cWaterfall}>
                      <CompareWaterfall
                        isCompare
                        compareElement={compareElement}
                        modelGroups={modelGroups}
                        compareScenarioIndex={compareScenarioIndex}
                        viewingScenarioIndex={viewingScenarioIndex}
                        updateCompareScenarioIndex={updateCompareScenarioIndex}
                        updateViewScenarioIndex={(index) =>
                          project.settings.scenarios.length > index
                            ? viewScenario(project.settings.scenarios[index], index)
                            : {}
                        }
                        project={project}
                        viewScenario={{
                          scenarios: project.settings.scenarios[viewingScenarioIndex],
                          originalScenarios: project.settings.originalScenarios[viewingScenarioIndex],
                          scenarioStats: project.settings.scenarioStats[viewingScenarioIndex]
                        }}
                        compareScenario={{
                          scenarios: project.settings.scenarios[compareScenarioIndex],
                          originalScenarios: project.settings.originalScenarios[compareScenarioIndex],
                          scenarioStats: project.settings.scenarioStats[compareScenarioIndex]
                        }}
                        bars={[
                          {
                            label:
                              selectedScenario && selectedScenario.originalScenario
                                ? selectedScenario.originalScenario.name
                                : "Scenario 0",
                            value:
                              compareElement === "Profit"
                                ? project.settings.scenarioStats[viewingScenarioIndex].profit
                                : compareElement === "Revenue"
                                  ? project.settings.scenarioStats[viewingScenarioIndex].revenue
                                  : compareElement === "Cost"
                                    ? project.settings.scenarioStats[viewingScenarioIndex].cost
                                    : compareElement === "Error Cost"
                                      ? project.settings.scenarioStats[viewingScenarioIndex].overEstimate +
                                        project.settings.scenarioStats[viewingScenarioIndex].underEstimate
                                      : compareElement === "Overestimate Impact"
                                        ? project.settings.scenarioStats[viewingScenarioIndex].overEstimate
                                        : compareElement === "Underestimate Impact"
                                          ? project.settings.scenarioStats[viewingScenarioIndex].underEstimate
                                          : "",
                            tooltipLabel: compareElement
                          }
                        ].concat(
                          Object.keys(project.settings.scenarios[viewingScenarioIndex])
                            .filter(
                              (k) =>
                                k !== "Overall" ||
                                Object.keys(project.settings.scenarios[viewingScenarioIndex]).length === 1
                            )
                            .map((val, i) => ({
                              label: val,
                              color:
                                modelGroups &&
                                modelGroups.drilldownValues &&
                                modelGroups.drilldownValues.filter((d) => d.value === val).length > 0
                                  ? modelGroups.drilldownValues.filter((d) => d.value === val)[0].color
                                  : "gray",
                              value:
                                compareElement === "Profit"
                                  ? project.settings.scenarios[compareScenarioIndex][val].profit -
                                    project.settings.scenarios[viewingScenarioIndex][val].profit
                                  : compareElement === "Revenue"
                                    ? project.settings.scenarios[compareScenarioIndex][val].revenue -
                                      project.settings.scenarios[viewingScenarioIndex][val].revenue
                                    : compareElement === "Cost"
                                      ? project.settings.scenarios[compareScenarioIndex][val].cost -
                                        project.settings.scenarios[viewingScenarioIndex][val].cost
                                      : compareElement === "Error Cost"
                                        ? project.settings.scenarioStats[compareScenarioIndex].overEstimate +
                                          project.settings.scenarioStats[compareScenarioIndex].underEstimate -
                                          (project.settings.scenarioStats[viewingScenarioIndex].overEstimate +
                                            project.settings.scenarioStats[viewingScenarioIndex].underEstimate)
                                        : compareElement === "Overestimate Impact"
                                          ? project.settings.scenarioStats[compareScenarioIndex].overEstimate -
                                            project.settings.scenarioStats[viewingScenarioIndex].overEstimate
                                          : compareElement === "Underestimate Impact"
                                            ? project.settings.scenarioStats[compareScenarioIndex].underEstimate -
                                              project.settings.scenarioStats[viewingScenarioIndex].underEstimate
                                            : "",
                              tooltipLabel: compareElement + " Delta"
                            }))
                            .sort((a, b) => Math.abs(b.value) - Math.abs(a.value))
                        )}
                        totalLabel={hoverScenario ? hoverScenario.name : "Scenario " + compareScenarioIndex}
                        showLabel
                      />
                    </div>
                  ) : (
                    <div />
                  )}
                </div>
              </div>
              {assumptionCharts.length > 0 && false && (
                <div className={styles.cBlock} style={{ minWidth: "810px" }}>
                  <div className={styles.otherHeader} style={{ marginTop: "20px" }}>
                    {"Assumption Comparison"}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
